import React from 'react';

import AuFlag from '../../icons/flag-au.svg';
import CaFlag from '../../icons/flag-ca.svg';
import EuFlag from '../../icons/flag-eu.svg';
import NzFlag from '../../icons/flag-nz.svg';
import SaFlag from '../../icons/flag-sa.svg';
import UkFlag from '../../icons/flag-uk.svg';
import UsFlag from '../../icons/flag-us.svg';

import FlagTabs from './FlagTabs';

const tabs = [
  {
    title: 'United States',
    icon: UsFlag,
    to: '/pricing/us'
  },
  {
    title: 'Canada',
    icon: CaFlag,
    to: '/pricing/ca'
  },
  {
    title: 'South Africa',
    icon: SaFlag,
    to: '/pricing/za'
  },
  {
    title: 'Australia',
    icon: AuFlag,
    to: '/pricing/au'
  },
  {
    title: 'New Zealand',
    icon: NzFlag,
    to: '/pricing/nz'
  },
  {
    title: 'Europe',
    icon: EuFlag,
    to: '/pricing/eu'
  },
  {
    title: 'United Kingdom',
    icon: UkFlag,
    to: '/pricing/uk'
  }
];

const Flags = () => <FlagTabs tabs={tabs} />;

export default Flags;
